var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 24.0005C21.7999 24.0005 19.9999 22.2005 19.9999 20.0005C19.9999 17.8005 21.7999 16.0005 23.9999 16.0005C26.1999 16.0005 27.9999 17.8005 27.9999 20.0005C27.9999 22.2005 26.1999 24.0005 23.9999 24.0005ZM36 20.4005C36 13.1405 30.6999 8.00048 23.9999 8.00048C17.2999 8.00048 11.9999 13.1405 11.9999 20.4005C11.9999 25.0805 15.8999 31.2804 23.9999 38.6805C32.1 31.2804 36 25.0805 36 20.4005ZM23.9999 4.00049C32.4 4.00049 39.9999 10.4405 39.9999 20.4005C39.9999 27.0405 34.6599 34.9005 23.9999 44.0004C13.3399 34.9005 7.99988 27.0405 7.99988 20.4005C7.99988 10.4405 15.5999 4.00049 23.9999 4.00049Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/locationIcon.b9a5247697b7e654fd650482275ff50a.svg";
export { ForwardRef as ReactComponent };